const url = window.location.href;
const Homepage = `${url}services/`;

export default Homepage;
